import { createFileRoute } from '@tanstack/react-router';
import {
  PERMISSION_VEHICLE_GROUP_CUSTOMER,
  PERMISSION_VEHICLE_GROUP_PRIVATE,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/cars_groups_settings/add')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_VEHICLE_GROUP_CUSTOMER, PERMISSION_VEHICLE_GROUP_PRIVATE],
      ['create'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: {
        main: 'carsGroups.addGroup',
        suffix: 'carsGroups.carsGroups',
      },
    };
  },
  component: () => null,
});
